import { memo } from 'react'

import { Box, type LargeIcon, Section } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import BecomeForm from 'modules/security_settings/pages/SecuritySettingsPage/BecomeSection/BecomeForm'

interface Props {
  staffBecomeEnabled: boolean
}

function BecomeSection({ staffBecomeEnabled }: Props) {
  // FIXME: For the sections we're using the gamma <Section> component until <Title> and the new
  // <ResponsivePage> are available... since the old sections need to have an illustration, we'll
  // pass a fake one for now (which makes it not show any icon)
  const noIllustration = 'NO_ICON' as LargeIcon

  // The icon is not visible, but it still takes up space in the section's left column, so we need
  // to add some extra padding to the content to keep it aligned.
  const contentExtraTopPadding = 's48'

  return (
    <Section.TwoThirds
      title={i18n.t('security_settings.become.title')}
      description={i18n.t('security_settings.become.description')}
      illustration={noIllustration}
    >
      <Box paddingTop={contentExtraTopPadding}>
        <BecomeForm staffBecomeEnabled={staffBecomeEnabled} />
      </Box>
    </Section.TwoThirds>
  )
}

export default memo(BecomeSection)
